import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-173b5c92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invoice-container" }
const _hoisted_2 = {
  key: 0,
  class: "main"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "发票抬头", -1))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "tips mt4" }
const _hoisted_8 = {
  key: 0,
  class: "mt8"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("div", null, "收票信息")
], -1))
const _hoisted_10 = { class: "email-block" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload-tips" }, "点击下载证明模板并填写内容盖上公司印章，然后拍照上传。", -1))
const _hoisted_12 = { class: "upload-wrap common-wrap" }
const _hoisted_13 = {
  key: 1,
  class: "footer xag-page__footer"
}
const _hoisted_14 = { class: "content" }

import { reactive, computed, ComputedRef, ref, Ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter, Router } from 'vue-router'
import getRoute from '@/compositions/route'
import AppHeader from '@/components/Header.vue'
import { getUserInvoiceList } from '@/apis/invoice'
import { InvoiceItem } from '@/types/invoice'
import {
  invoiceTypeColorMap,
  invoiceTypeTextMap,
  invoiceListStorageKey,
  confirmUseInvoiceStorageKey,
  selectInoviceStorageKey,
} from './definition'
import { clearToast, showToastFail, showToastLoading } from '@/utils/tools'
import { Button, Field, Overlay, Image, ImagePreview, Toast } from 'vant'
import { setStorage } from '@/compositions/useMultiPlatformStorage'
import FormItemWrap from './components/form-item-wrap.vue'
import { useValiedateEmail } from '@/compositions/useValidate'
import type { CommonUploaderFileListItem } from '@/types/public'
import UploadImageWrap from '@/components/upload/UploadImage.vue'
import DownloadCertificateTemplate from './components/certificate-template.vue'

interface invoiceInfoType {
  invoiceTypeColor: string
  invoiceTypeText: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'confirm-qd',
  setup(__props) {

/* eslint-disable @typescript-eslint/no-unused-vars */
const $router: Router = useRouter()
const { query } = getRoute()
const needInvoice: string = (query.value.needInvoice as string) || '0'
const showCancelBtn: ComputedRef<boolean> = computed(() => {
  let need = Number(needInvoice)
  return Boolean(need)
})

const page: {
  invoiceList: InvoiceItem[]
  currentInvoice: InvoiceItem | null
} = reactive({
  invoiceList: [] as InvoiceItem[],
  currentInvoice: null,
})
const invoiceInfo: ComputedRef<invoiceInfoType> = computed(() => {
  let currentInvoice = page.currentInvoice
  return {
    invoiceTypeColor: invoiceTypeColorMap.get(currentInvoice.invoice_type),
    invoiceTypeText: invoiceTypeTextMap.get(currentInvoice.invoice_type),
  }
})
// 邮箱
const email = ref('')
// 待付款证明
const uploadCertificateList: Ref<CommonUploaderFileListItem[]> = ref([])
function invoiceClickHandle() {
  const invoiceList = page.invoiceList
  if (invoiceList.length) {
    // 去列表
    $router.push({
      name: 'invoice-select-qd',
    })
  } else {
    // 去编辑页面
    $router.push({
      name: 'invoice-edit-qd',
    })
  }
}
const isVatSpecialInvoice: ComputedRef<boolean> = computed(() => {
  return page.currentInvoice.invoice_type === 1
})
function confirmUse() {
  let invoiceGuid = page.currentInvoice.guid
  if (!invoiceGuid) {
    showToastFail('未选择发票')
    return
  }
  if (!useValiedateEmail(email.value)) {
    showToastFail('请输入正确的邮箱地址')
    return
  }
  // 全电专票需要上传待付款证明
  if (isVatSpecialInvoice.value && !uploadCertificateList.value.length) {
    showToastFail('请上传代付款证明')
    return
  }
  setStorage(confirmUseInvoiceStorageKey, {
    invoice: { ...page.currentInvoice },
    email: email.value,
    certificate: isVatSpecialInvoice.value ? uploadCertificateList.value : [],
    needInvoice: true,
  })
  $router.go(-1)
}
function cancelUse() {
  setStorage(confirmUseInvoiceStorageKey, {
    needInvoice: false,
  })
  $router.go(-1)
}

const isLoading = ref(false)
async function initInvoice() {
  isLoading.value = true
  let storageStr = sessionStorage.getItem(invoiceListStorageKey)
  let data: InvoiceItem[]
  if (storageStr) {
    data = JSON.parse(storageStr)
  } else {
    showToastLoading()
    try {
      data = await getUserInvoiceList()
      sessionStorage.setItem(invoiceListStorageKey, JSON.stringify(data))
      clearToast()
    } catch (e) {
      showToastFail(e && e.message)
    }
  }
  let comfirmStorageGuid = ''
  const invoiceInfoJSON = sessionStorage.getItem(confirmUseInvoiceStorageKey)
  if (invoiceInfoJSON) {
    let invoiceInfo = JSON.parse(invoiceInfoJSON)
    comfirmStorageGuid = invoiceInfo.invoice.guid
    let needInvoice = invoiceInfo.needInvoice
    if (needInvoice) {
      email.value = invoiceInfo.email
      // 加载已上传的待付款证明
      uploadCertificateList.value = invoiceInfo.certificate
    }
  }
  let selectStorageGuid = sessionStorage.getItem(selectInoviceStorageKey)
  let invoiceShowGuid = selectStorageGuid || comfirmStorageGuid
  if (data) {
    let defaultItem
    let selectedItem
    for (let i = 0; i < data.length; i++) {
      if (data[i].default) {
        defaultItem = data[i]
      }
      if (data[i].guid === invoiceShowGuid) {
        selectedItem = data[i]
      }
    }
    page.currentInvoice = selectedItem || defaultItem || data[0] || null
    page.invoiceList = data
  }
  sessionStorage.removeItem(selectInoviceStorageKey)
  isLoading.value = false
}

function uploadImageChange(list: CommonUploaderFileListItem[]) {
  console.log('upload-image-change', list)
  uploadCertificateList.value = list
}

initInvoice()

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppHeader, { title: "发票" }),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _hoisted_3,
            _createElementVNode("div", {
              class: "invoice-block",
              onClick: invoiceClickHandle
            }, [
              _createElementVNode("div", _hoisted_4, [
                (page.invoiceList.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, "新增发票抬头"))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("span", {
                          style: _normalizeStyle('color:' + _unref(invoiceInfo).invoiceTypeColor)
                        }, "[" + _toDisplayString(_unref(invoiceInfo).invoiceTypeText) + "]", 5),
                        _createElementVNode("span", null, _toDisplayString(page.currentInvoice.header), 1)
                      ]),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(page.currentInvoice.taxpayer_no), 1)
                    ], 64))
              ]),
              _createVNode(_component_van_icon, {
                name: "arrow",
                class: "arrow-item"
              })
            ])
          ]),
          (page.invoiceList.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(FormItemWrap, {
                    label: "收票邮箱",
                    require: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Field), {
                        modelValue: email.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                        class: "input-class",
                        placeholder: "邮箱地址"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (_unref(isVatSpecialInvoice))
                    ? (_openBlock(), _createBlock(FormItemWrap, {
                        key: 0,
                        label: "代付款证明",
                        require: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(DownloadCertificateTemplate, { class: "upload-template-download" }),
                          _hoisted_11,
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(UploadImageWrap, {
                              defaultList: uploadCertificateList.value,
                              "max-count": 1,
                              useCrmUpload: true,
                              onChange: uploadImageChange
                            }, null, 8, ["defaultList"])
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_unref(Button), {
              block: "",
              class: "confirm-button",
              onClick: confirmUse
            }, {
              default: _withCtx(() => [
                _createTextVNode("确定发票申请")
              ]),
              _: 1
            }),
            (!_unref(showCancelBtn))
              ? (_openBlock(), _createBlock(_unref(Button), {
                  key: 0,
                  block: "",
                  onClick: cancelUse
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("不开发票")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})